export const SERVICE_ID = "ssp";

export const globalEnv = {
  appName: import.meta.env.VITE_APP_NAME,
  baseUrl: import.meta.env.BASE_URL,
  socioGrpcApiEnv: import.meta.env.VITE_APP_SOCIO_GRPC_API_ENV,
  serviceId: import.meta.env.VITE_APP_SSP_SERVICE_ID,
  documentBackUrl: import.meta.env.VITE_APP_U_DOCUMENT_BACK_URL,
  cloudId: import.meta.env.VITE_APP_CLOUD_ID,
  displayNewNavItems: import.meta.env.VITE_APP_DISPLAY_NEW_NAVIGATION_ITEMS,
  backUrl: import.meta.env.VITE_APP_BACK_URL,
  serviceSlug: import.meta.env.VUE_APP_SERVICE_SLUG,
  i18nLocale: import.meta.env.VITE_APP_I18N_LOCALE,
  i18nFallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE,
  mapBoxApiKey: import.meta.env.VITE_APP_MAP_BOX,
  ssoUrl: import.meta.env.VITE_APP_SSO_URL,
  ssoClientId: import.meta.env.VITE_APP_SSO_CLIENT_ID_FRONT,
  apiBasePath: import.meta.env.VITE_APP_API_BASE_PATH,
  contributorsRestApiUrl: import.meta.env.VITE_APP_CONTRIBUTORS_REST_API_URL,
  documentRestApiUrl: import.meta.env.VITE_APP_DOCUMENT_REST_API_URL,
  pulRestApiUrl: import.meta.env.VITE_APP_PRODUCTION_UNIT_LISTER_REST_API_URL,
  atlasRestApiUrl: import.meta.env.VITE_APP_ATLAS_AS_A_SERVICE_REST_API_URL,
  materialsRestApiUrl: import.meta.env.VITE_APP_MATERIALS_REST_API_URL,
  reportGeneratorRestApiUrl: import.meta.env.VITE_APP_REPORT_GENERATOR_REST_API_URL,
  bimdataApiBaseUrl: import.meta.env.VITE_APP_BD_API_BASE_URL,
  enableTelemetry: import.meta.env.VITE_APP_ENABLE_TELEMETRY,
};
export const EUROFIN_CATALOG_REFERENCE = "I92M06220020-11";
export const EUROFINS_SSP_CATALOG_KEYWORDS = ["catalogue site", "sols pollué"];
export const diagnostic_paragraphs = [
  {
    label: "1. RÉSUMÉ NON TECHNIQUE",
    value: "1",
  },
  {
    label: "2. PRÉSENTATION DE LA MISSION",
    value: "2",
    children: [
      { label: "2.1. SITE D’INTERVENTION", value: "2-1" },
      { label: "2.2. CONTEXTE ET OBJECTIF DE LA MISSION", value: "2-2" },
      { label: "2.3. CONTENU DE LA MISSION", value: "2-3" },
      { label: "2.4. DOCUMENTS DE RÉFÉRENCE", value: "2-4" },
      { label: "2.5. RÉFÉRENTIEL MÉTHODOLOGIQUE", value: "2-5" },
      { label: "2.6. SYNTHÉSE DES ÉTUDES ANTÉRIEURES", value: "2-6" },
    ],
  },
  {
    label: "3. MISSION GLOBALE INFOS+DIAG",
    value: "3",
    children: [
      {
        label: "3.1. VISITE DE SITE (A100)",
        value: "3-1",
        children: [
          {
            label: "3.1.1. REALISATION DE LA VISITE ET PERSONNE(S) RENCONTREE(S)",
            value: "3-1-1",
          },
          {
            label: "3.1.2. DESCRIPTION DU SITE, DES ACTIVITÉS ET DES INSTALLATIONS RECENSEES",
            value: "3-1-2",
          },
          {
            label: "3.1.3. PRESENCE AVÉRÉE DE REMBLAIS OU DE POLLUTION",
            value: "3-1-3",
          },
          {
            label: "3.1.4. INFORMATIONS RECUEILLIES PAR TÉMOIGNAGE LORS DE LA VISITE DE SITE",
            value: "3-1-4",
          },
          {
            label: "3.1.5. USAGES CONSTATÉS ET SENSIBILITÉ DU VOISINAGE",
            value: "3-1-5",
          },
          {
            label: "3.1.6. DANGERS IMMÉDIATS POUR L’ENVIRONNEMENT ET LA SANTÉ PUBLIQUE",
            value: "3-1-6",
          },
          {
            label: "3.1.7. MESURES CORRECTIVES DE MISE EN SÉCURITÉ",
            value: "3-1-7",
          },
          {
            label: "3.1.8. IDENTIFICATION DES CONTRAINTES SUR SITE",
            value: "3-1-8",
          },
        ],
      },
      {
        label: "3.2. ETUDE HISTORIQUE, DOCUMENTAIRE ET MÉMORIELLE (A110)",
        value: "3-2",
        children: [
          {
            label: "3.2.1. SOURCES D’INFORMATION ET DOCUMENTS CONSULTÉS",
            value: "3-2-1",
          },
          {
            label: "3.2.2. INFORMATIONS RECUEILLIES LORS D’ENTRETIENS (HORS ACCOMPAGNATEUR)",
            value: "3-2-2",
          },
          {
            label: "3.2.3. ANALYSE DES PHOTOGRAPHIES AÉRIENNES ANCIENNES",
            value: "3-2-3",
          },
          {
            label:
              "3.2.4. ANALYSE DES DOCUMENTS COLLECTÉS AUPRÈS DES SOURCES CONSULTÉES (ARCHIVES…)",
            value: "3-2-4",
          },
          {
            label: "3.2.5. HISTORIQUE DES SITUATIONS ADMINISTRATIVES",
            value: "3-2-5",
          },
          {
            label: "3.2.6. HISTORIQUE DES ACTIVITÉS ET PROCÉDÉS",
            value: "3-2-6",
          },
          {
            label:
              "3.2.7. PRODUITS UTILISÉS, CONDITIONS DE STOCKAGE, D’EMPLOI OU D’ÉLIMINATION OU VALORISATION DES PRODUITS NEUFS OU USAGÉS",
            value: "3-2-7",
          },
          { label: "3.2.8. EPANDAGE", value: "3-2-8" },
          {
            label: "3.2.9. INVENTAIRE DES INCIDENTS/ACCIDENTS",
            value: "3-2-9",
          },
          {
            label: "3.2.10. CONTRAINTES IMPOSÉES PAR LE BIAIS DE RESTRICTIONS D’USAGE",
            value: "3-2-10",
          },
          {
            label: "3.2.11. ACTIVITÉS À RISQUES EXERCÉES AU VOISINAGE IMMÉDIAT DU SITE",
            value: "3-2-11",
          },
          {
            label: "3.2.12. SYNTHÈSE DE L’ÉTUDE HISTORIQUE, DOCUMENTAIRE ET MÉMORIELLE",
            value: "3-2-12",
          },
        ],
      },
      {
        label: "3.3. ETUDE DE VULNÉRABILITÉ DES MILIEUX (A120)",
        value: "3-3",
        children: [
          {
            label: "3.3.1. SOURCES D'INFORMATION ET DOCUMENTS CONSULTÉS",
            value: "3-3-1",
          },
          {
            label: "3.3.2. DESCRIPTION ET USAGES DES SOLS SUR ET HORS SITE",
            value: "3-3-2",
            children: [
              {
                label: "3.3.2.1 SITUATION GÉOGRAPHIQUE ET TOPOGRAPHIQUE",
                value: "3-3-2-1",
              },
              { label: "3.3.2.2 CONTEXTE GÉOLOGIQUE", value: "3-3-2-2" },
              {
                label: "3.3.2.3 DESCRIPTION DES SURFACES AU SOL",
                value: "3-3-2-3",
              },
              { label: "3.3.2.4 OCCUPATION DU SOL", value: "3-3-2-4" },
            ],
          },
          {
            label: "3.3.3. DESCRIPTION ET USAGES DES EAUX SOUTERRAINES SUR ET HORS SITE",
            value: "3-3-3",
            children: [
              { label: "3.3.3.1 CONTEXTE HYDROGÉOLOGIQUE", value: "3-3-3-1" },
              {
                label: "3.3.3.2 USAGE DES EAUX SOUTERRAINES",
                value: "3-3-3-2",
              },
            ],
          },
          {
            label: "3.3.4. DESCRIPTION ET USAGES DES EAUX SUPERFICIELLES SUR ET HORS SITE",
            value: "3-3-4",
            children: [
              { label: "3.3.4.1 CONTEXTE HYDROLOGIQUE", value: "3-3-4-1" },
              {
                label: "3.3.4.2 USAGE DES EAUX SUPERFICIELLES",
                value: "3-3-4-2",
              },
            ],
          },
          { label: "3.3.5. CONTEXTE MÉTÉOROLOGIQUE", value: "3-3-5" },
          { label: "3.3.6. PATRIMOINE NATUREL", value: "3-3-6" },
          {
            label: "3.3.7. IDENTIFICATION DES MILIEUX RETENUS POUR INVESTIGATIONS",
            value: "3-3-7",
          },
        ],
      },
      {
        label:
          "3.4. ELABORATION D’UN PROGRAMME PRÉVISIONNEL D’INVESTIGATIONS SUR LES MILIEUX (A130)",
        value: "3-4",
        children: [
          {
            label: "3.4.1. SCHÉMA CONCEPTUEL",
            value: "3-4-1",
            children: [
              { label: "3.4.1.1 HYPOTHÈSES CONSIDÉRÉES", value: "3-4-1-1" },
              { label: "3.4.1.2 MILIEUX CONSIDÉRÉS", value: "3-4-1-2" },
              { label: "3.4.1.3 POLLUANTS CONSIDÉRÉS", value: "3-4-1-3" },
              { label: "3.4.1.4 USAGE ET CIBLES CONSIDÉRÉS", value: "3-4-1-4" },
              {
                label: "3.4.1.5 VOIES DE TRANSFERT ET D’EXPOSITION CONSIDÉRÉES SUR SITE",
                value: "3-4-1-5",
              },
              {
                label: "3.4.1.6 TRANSFERT DE POLLUTION HORS SITE",
                value: "3-4-1-6",
              },
              {
                label: "3.4.1.7 VOIES DE TRANSFERT ET D’EXPOSITION CONSIDÉRÉES HORS SITE",
                value: "3-4-1-7",
              },
            ],
          },
          {
            label: "3.4.2. RAPPEL DES OBJECTIFS ET DU CONTEXTE DE LA MISSION",
            value: "3-4-2",
          },
          {
            label: "3.4.3. PROGRAMME PRÉVISIONNEL D’INVESTIGATIONS",
            value: "3-4-3",
          },
        ],
      },
    ],
  },
  {
    label: "4. DIAGNOSTIC DES MILIEUX (DIAG)",
    value: "4",
    children: [
      {
        label: "4.1. HYGIÈNE ET SÉCURITÉ",
        value: "4-1",
      },
      {
        label:
          "4.2. SYNTHÈSE DE L'ÉLABORATION DU PROGRAMME PRÉVISIONNEL D'INVESTIGATIONS SUR LES MILIEUX",
        value: "4-2",
      },
      {
        label: "4.3. INVESTIGATIONS RÉALISÉES",
        value: "4-3",
      },
      {
        label: "4.4. PRÉLÈVEMENTS, MESURES, OBSERVATIONS ET/OU ANALYSES SUR LES SOLS (A200)",
        value: "4-4",
        code: "A200",
      },
      {
        label:
          "4.5. PRÉLÈVEMENTS, MESURES, OBSERVATIONS ET/OU ANALYSES SUR LES EAUX SOUTERRAINES (A210)",
        value: "4-5",
        code: "A210",
      },
      {
        label:
          "4.6. PRÉLÈVEMENTS, MESURES, OBSERVATIONS ET/OU ANALYSES SUR LES EAUX SUPERFICIELLES / SÉDIMENTS (A220)",
        value: "4-6",
        code: "A220",
      },
      {
        label:
          "4.7. PRÉLÈVEMENTS, MESURES, OBSERVATIONS ET/OU ANALYSES SUR LES GAZ DES SOLS (A230)",
        value: "4-7",
        code: "A230",
      },
      {
        label:
          "4.8. PRÉLÈVEMENTS, MESURES, OBSERVATIONS ET/OU ANALYSES SUR L'AIR AMBIANT ET LES POUSSIÈRES ATMOSPHÉRIQUES (A240)",
        value: "4-8",
        code: "A240",
      },
      {
        label:
          "4.9. PRÉLÈVEMENTS, MESURES, OBSERVATIONS ET/OU ANALYSES SUR LES DENRÉES ALIMENTAIRES ET EAU DU ROBINET (A250)",
        value: "4-9",
        code: "A250",
      },
      {
        label:
          "4.10. PRÉLÈVEMENTS, MESURES, OBSERVATIONS ET/OU ANALYSES SUR LES TERRES EXCAVÉES / A EXCAVER (A260)",
        value: "4-10",
        code: "A260",
      },
      {
        label: "4.11. INTERPRÉTATION DES RÉSULTATS DES INVESTIGATIONS (A270)",
        value: "4-11",
        code: "A270",
      },
    ],
  },
  { label: "5. EVALUATION DES INCERTITUDES", value: "5" },
  { label: "6. SYNTHÈSE TECHNIQUE / RECOMMANDATIONS", value: "6" },
];
